import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['requests', 'logs'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({}),
        treatListResponse: treatsItems({
          datetimeFieldNames: ['datetime'],
        }),
      }),
      makeQueryParams: makeListRequest({}),
      makeHttpParamsUrl: (id) =>
        `${process.env.P2C_BASE_URI}/requests/${id}/logs`,
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'requests/logs',
    paramId: 'requestId',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.onActiveRequestChange((request) => {
      store.dispatch(`requests/logs/setUrlParamId`, request.id);
    });
  });
};
